import './Customize.module.css';

import {
  Link,
  Typography
} from '@material-ui/core';
import React from 'react';

import CustomizeBoard from '../../CustomizeBoard';
import NavigationWrap from '../../NavigationWrap';
import WithProvider from '../../WithProvider';

export default function CustomizePage() {
  return (
    <NavigationWrap>
      <WithProvider>
        <CustomizeBoard />
      </WithProvider>
      <div styleName="wrap">
        <Typography component="h1" gutterBottom variant="h5">Create and customize your own Sudoku!</Typography>
        <Typography paragraph>
          Take a stab at creating your own Sudoku puzzles. You can replace the usual numbers (1 through 9) with any characters like &quot;abcdefghi&quot; as long as each character is unique. Non-English characters can also be used, and&nbsp;
          <Link href="/customize/chinese">Chinese Sudoku</Link>
          &nbsp;is a great example of this.
        </Typography>
      </div>
    </NavigationWrap>
  );
}
